<template >
  <v-app class="back">
    <v-container fluid class="doc">
      <v-row justify="start" class="my-4 ml-1">
        <span class="display-1 titulo font-weight-bold">Planos</span>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12" md="9">
          <v-card outlined class="borda" flat width="100%">
            <v-data-table
              no-data-text="Nenhum plano cadastrado"
              hide-default-footer
              :headers="cabecalho"
              :items="formData"
              :items-per-page="items_per_pag"
              class="elevation-0"
              :loading="loading"
            >
              <template v-slot:item.acao="{ item }">
                <v-tooltip top color="black" v-if="!editModulo">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on" text>
                      <v-icon>mdi-information-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>
                    Sem autorização para
                    <span class="orange--text">editar</span> ou
                    <span class="red--text">excluir</span>
                  </span>
                </v-tooltip>
                <v-menu offset-x v-if="editModulo">
                  <template v-slot:activator="{ on }">
                    <v-btn icon text v-on="on">
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <div v-for="(iten, index) in opcoes" :key="index">
                      <v-list-item @click="menu(iten,item)">
                        <v-icon>{{ iten.icon }}</v-icon>
                        <v-list-item-title>{{ iten.nome }}</v-list-item-title>
                      </v-list-item>
                    </div>
                  </v-list>
                </v-menu>
              </template>
              <template v-slot:footer>
                <v-row justify="center" class="mb-2">
                  <v-btn
                    v-if="items_per_pag > 10"
                    @click="items_per_pag -= 10"
                    text
                    color="#1F36C7"
                  >Mostrar menos</v-btn>
                  <v-btn
                    v-if="formData.length > items_per_pag"
                    @click="carregarMais()"
                    text
                    color="#1F36C7"
                  >Carregar mais</v-btn>
                </v-row>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
        <v-col sm="12" md="3">
          <v-row>
            <v-card flat width="100%" height="100%" class="mr-4 borda" v-if="editModulo">
              <v-col class="mr-8">
                <v-btn
                  @click="novoPlano()"
                  large
                  rounded
                  block
                  class
                  style="background-color: #283480  !important;"
                >
                  <v-icon style="color: #00ffd4 !important" class="mr-1">mdi-account-multiple-plus</v-icon>
                  <span class="white--text">Novo plano</span>
                </v-btn>
              </v-col>
            </v-card>
          </v-row>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog v-model="dialog_planos" scrollable persistent width="1050px">
      <v-form ref="form" v-model="valid" @submit.prevent="save()">
        <v-card flat class="borda">
          <v-card-title class="ma-2">
            <span v-if="!novos_planos.id_plano_clube">Novo plano</span>
            <span v-else>Editar plano</span>
            <v-spacer></v-spacer>
            <v-btn icon text @click="close()">
              <v-icon>mdi-close-thick</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="12" md="6" class="mb-n5">
                <span class="font-weight-bold black--text">Nome *</span>
                <v-text-field
                  :rules="requiredRules"
                  v-model="novos_planos.plano_clube_nome"
                  solo
                  dense
                  flat
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3" class="mb-n5">
                <v-card-text class="mt-7">
                  <v-checkbox
                    @change="clearCampos()"
                    value="1"
                    class="mb-n7 mt-n5"
                    label="Plano gratuito"
                    v-model="novos_planos.plano_clube_gratuito"
                  ></v-checkbox>
                </v-card-text>
              </v-col>
              <v-col cols="12" sm="6" md="3" class="mb-n5">
                <v-card-text class="mt-5">
                  <v-checkbox
                    class="mb-n7 mt-n5"
                    label="Período contrato indeterminado"
                    v-model="checkboxPeriodo"
                    @change="checkPeriodo()"
                  ></v-checkbox>
                </v-card-text>
              </v-col>
              <v-col cols="12" sm="12" md="4" class="mb-n5">
                <span class="font-weight-bold black--text">Valor</span>
                <span
                  class="font-weight-bold black--text"
                  v-if="!novos_planos.plano_clube_gratuito"
                >*</span>
                <money
                  class="input"
                  :disabled="novos_planos.plano_clube_gratuito == 1"
                  v-model.lazy="novos_planos.plano_clube_valor"
                  v-bind="moneyFormat"
                  :rules="RulesPago"
                ></money>
                <!-- <v-text-field v-model="nova_conta.conta_saldo_inicial" solo dense flat outlined></v-text-field> -->
              </v-col>
              <v-col cols="12" sm="12" md="4" class="mb-n5">
                <span class="font-weight-bold black--text">Conta *</span>
                <v-select
                  label="Selecione"
                  no-data-text="Sem registro"
                  v-model="novos_planos.fk_id_conta"
                  solo
                  dense
                  flat
                  outlined
                  clearable
                  item-text="conta_nome"
                  item-value="id_conta"
                  :items="contas"
                  :rules="requiredRules"
                  required
                ></v-select>
              </v-col>
              <v-col cols="12" sm="12" md="4" class="mb-n5">
                <v-row no-gutters>
                  <span class="font-weight-bold black--text">Método de pagamento</span>
                  <span
                    class="font-weight-bold black--text"
                    v-if="!novos_planos.plano_clube_gratuito"
                  >*</span>
                  <v-spacer></v-spacer>
                  <a @click="dialog_taxas = true">Taxas Online</a>
                </v-row>
                <v-select
                  label="Selecione"
                  no-data-text="Método de pagamento"
                  v-model="novos_planos.plano_clube_metodo_pagamento"
                  :disabled="novos_planos.plano_clube_gratuito == 1"
                  solo
                  dense
                  :rules="RulesPago"
                  flat
                  outlined
                  clearable
                  item-text="name"
                  item-value="value"
                  :items="metodos"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="12" md="4" class="mb-n5">
                <span class="font-weight-bold black--text">Método de cobrança</span>
                <span
                  class="font-weight-bold black--text"
                  v-if="!novos_planos.plano_clube_gratuito"
                >*</span>
                <v-select
                  :disabled="novos_planos.plano_clube_gratuito == 1"
                  label="Selecione"
                  no-data-text="Método de cobrança"
                  v-model="novos_planos.plano_clube_metodo_cobranca"
                  solo
                  dense
                  flat
                  :rules="RulesPago"
                  clearable
                  outlined
                  item-text="name"
                  item-value="value"
                  :items="metodosCobranca"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="12" md="4" class="mb-n5">
                <span class="font-weight-bold black--text">Data específica</span>
                <v-menu
                  v-model="menu1"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      solo
                      flat
                      outlined
                      dense
                      @blur="novos_planos.plano_clube_metodo_cobranca_data_especifica = parseDate(dateFormatted)"
                      v-model="dateFormatted"
                      append-icon="mdi-calendar"
                      clearable
                      v-mask="data_mask"
                      v-on="on"
                      :rules="requiredRulesData"
                      :disabled="novos_planos.plano_clube_gratuito == 1 || novos_planos.plano_clube_metodo_cobranca != 3"
                      @input="menu1 = false"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="date"
                    no-title
                    :disabled="novos_planos.plano_clube_gratuito == 1"
                    locale="pt-br"
                    @input="menu1 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <span class="font-weight-bold black--text">Quantos dias antes gerar débito?*</span>
                <v-text-field
                  :rules="requiredRulesDebito"
                  v-model="novos_planos.dias_gerar_debito"
                  solo
                  dense
                  flat
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="4" class="mb-n5">
                <span class="font-weight-bold black--text">Período de pagamento</span>
                <v-select
                  :disabled="novos_planos.plano_clube_gratuito == 1"
                  label="Selecione"
                  no-data-text="Período de pagamento"
                  v-model="novos_planos.plano_clube_periodo_pagamento"
                  solo
                  dense
                  flat
                  :rules="RulesPago"
                  clearable
                  outlined
                  item-text="name"
                  item-value="value"
                  :items="periodosPagamento"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="12" md="4" class="mb-n5">
                <span class="font-weight-bold black--text">
                  Provisionamento fluxo de caixa em
                  <span
                    v-if="novos_planos.plano_clube_periodo_pagamento == 1"
                  >meses</span>
                  <span v-if="novos_planos.plano_clube_periodo_pagamento == 2">trimestres</span>
                  <span v-if="novos_planos.plano_clube_periodo_pagamento == 3">semestres</span>
                  <span v-if="novos_planos.plano_clube_periodo_pagamento == 4">anos</span>
                  *
                </span>
                <v-text-field
                  :rules="requiredRules"
                  type="number"
                  v-model="novos_planos.plano_clube_provisionamento_meses"
                  solo
                  dense
                  flat
                  outlined
                  min="0"
                  max="36"
                  :disabled="!novos_planos.plano_clube_periodo_pagamento"
                  oninput="if(Number(this.value) > Number(this.max)) this.value = this.max;"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="4" class="mb-n5">
                <span class="font-weight-bold black--text">
                  Máximo de
                  <span v-if="novos_planos.plano_clube_periodo_pagamento == 1">meses</span>
                  <span v-if="novos_planos.plano_clube_periodo_pagamento == 2">trimestres</span>
                  <span v-if="novos_planos.plano_clube_periodo_pagamento == 3">semestres</span>
                  <span v-if="novos_planos.plano_clube_periodo_pagamento == 4">anos</span>
                  *
                </span>
                <v-text-field
                  :rules="requiredRulesMensal"
                  v-model="novos_planos.plano_clube_maximo_mensalidades"
                  :disabled="checkboxPeriodo"
                  solo
                  dense
                  flat
                  outlined
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="12" md="12" class="mb-n5">
                <span class="font-weight-bold black--text">Descrição *</span>
                <v-textarea
                  :rules="requiredRules"
                  label="Descrição"
                  solo
                  v-model="novos_planos.plano_clube_descricao"
                  outlined
                  flat
                  auto-grow
                ></v-textarea>
              </v-col>
              <v-col cols="12" sm="12" md="12" class="mb-n5 mt-n5">
                <v-row>
                  <v-tooltip color="black" right>
                    <template v-slot:activator="{ on, attrs }">
                      <v-col md="auto" v-bind="attrs" v-on="on">
                        <v-switch
                          false-value="0"
                          true-value="1"
                          v-model="novos_planos.plano_publico"
                          label="Plano público"
                        ></v-switch>
                      </v-col>
                    </template>
                    <span>Ao marcar está opção o plano irá aparece no <b style="color: #81d4fa">Hotsite</b> do clube.</span>
                  </v-tooltip>
                </v-row>
              </v-col>
              <v-col>
                <span class="font-weight-bold black--text">Modelo de e-mail</span>
                <div class="mb-4 mt-2">
                  <span class="font-weight-bold black--text">Variáveis:</span>
                  <button type="button" class="ml-2" rounded @click="addVal('nome')">
                    <span>Nome do associado</span>
                  </button>
                  <button type="button" class="ml-2" rounded @click="addVal('plano')">
                    <span>Plano</span>
                  </button>
                </div>
                <vue-editor
                  v-model="novos_planos.plano_clube_email_template"
                  :editorToolbar="editor.customToolbar"
                ></vue-editor>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-row class="mb-4" no-gutters justify="center">
              <v-btn
                class="mr-2"
                @click="close()"
                rounded
                style="color: #283480 !important"
                outlined
              >Cancelar</v-btn>
              <v-btn
                class="ml-2"
                rounded
                style="background-color: #283480  !important; color:#00FFD4  !important"
                @click="save()"
              >
                <v-icon>mdi-content-save</v-icon>
                <span>Salvar</span>
              </v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-dialog v-model="dialog_delete" persistent max-width="400">
      <v-card class="borda" flat>
        <v-card-title class="headline">Tem certeza que deseja deletar este plano?</v-card-title>
        <v-card-text>Se deletar este plano ele não poderá ser recuperado!!</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn outlined rounded color="#283480" @click="dialog_delete = false">Cancelar</v-btn>
          <v-btn
            style="background-color: #283480  !important; color:#00FFD4  !important"
            rounded
            @click="deleteItem(), dialog_delete = false"
          >Sim, tenho certeza</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_taxas" width="600">
      <taxas></taxas>
    </v-dialog>
  </v-app>
</template>

<script>
import Api from "@/common/api.helper";
import { VueEditor } from "vue2-editor";
import taxas from "./clube_taxas";
export default {
  components: {
    VueEditor,
    taxas
  },
  data: () => {
    return {
      dialog_taxas: false,
      checkboxPeriodo: false,
      editor: {
        customToolbar: [
          ["bold", "italic", "underline"],
          [{ list: "ordered" }, { list: "bullet" }],
          [{ header: [false, 1, 2, 3, 4, 5] }],
          ["link", "video"],
          ["clean"]
        ],
        style: "font-size:12px!important"
        // content: this.value
      },
      moneyFormat: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
        masked: false
      },
      metodos: [
        { name: "Online", value: 1 },
        { name: "Offline", value: 2 },
        { name: "Ambos", value: 3 }
      ],
      metodosCobranca: [
        { name: "Data Específica", value: 3 },
        { name: "Data Inscrição", value: 1 }
      ],
      periodosPagamento: [
        { name: "Mensal", value: 1 },
        { name: "Trimestral", value: 2 },
        { name: "Semestral", value: 3 },
        { name: "Anual", value: 4 }
      ],
      loading: "false",
      data_mask: "##/##/####",
      opcoes: [
        { nome: "⠀Editar", icon: "mdi-pencil-outline" },
        { nome: "⠀Excluir", icon: "mdi-delete-outline" }
      ],
      plano_indeterminado: false,
      menu1: false,
      menu2: false,
      dialog_planos: false,
      dialog_edit_planos: false,
      dialog_delete: false,
      formData: [],
      date: "",
      dateFormatted: "",
      novos_planos: {
        plano_publico: 0,
        id_plano_clube: "",
        plano_clube_nome: "",
        plano_clube_descricao: "",
        plano_clube_gratuito: "",
        plano_clube_periodo_indeterminado: "",
        plano_clube_valor: "",
        plano_clube_metodo_pagamento: "",
        plano_clube_metodo_cobranca: "",
        plano_clube_maximo_mensalidades: "1",
        plano_clube_metodo_cobranca_competencia_inicio: "",
        plano_clube_metodo_cobranca_competencia_fim: "",
        plano_clube_metodo_cobranca_data_especifica: "",
        plano_clube_email_template: "",
        plano_clube_provisionamento_meses: 1,
        plano_clube_periodo_pagamento: "",
        dias_gerar_debito: "",
        fk_id_conta: ""
      },
      requiredRulesDebito: [
        v => !!v || "Campo Obrigatório.",
        v => v >= 0 || "Valor deve ser maior ou igual a 0"
      ],
      requiredRulesMensali: [v => !!v | (v == 0) || "Campo Obrigatório."],
      valid: true,
      requiredRules: [v => !!v || "Campo Obrigatório."],
      items_per_pag: 10,
      contas: [],
      cabecalho: [
        { text: "Nome", align: "start", value: "plano_clube_nome" },
        { text: "Descrição", align: "start", value: "plano_clube_descricao" },
        { text: "Ações", align: "end", sortable: false, value: "acao" }
      ],
      editModulo: false
    };
  },
  computed: {
    RulesPago() {
      let rules = [v => !!v || "Campo Obrigatório."];
      if (this.novos_planos.plano_clube_gratuito) {
        rules = [];
      }
      return rules;
    },
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
    requiredRulesMensal() {
      let requiredRulesMensali = [];
      if (this.checkboxPeriodo) {
        requiredRulesMensali = [];
      } else {
        requiredRulesMensali = [v => !!v || "Campo Obrigatório."];
      }
      return requiredRulesMensali;
    },
    requiredRulesData() {
      let requiredRulesDate = [];
      if (
        this.novos_planos.plano_clube_gratuito != 1 &&
        this.novos_planos.plano_clube_metodo_cobranca == 3
      ) {
        requiredRulesDate = [v => !!v || "Campo Obrigatório."];
      } else {
        requiredRulesDate = [];
      }
      return requiredRulesDate;
    }
  },
  watch: {
    date() {
      this.dateFormatted = this.formatDate(this.date);
      this.novos_planos.plano_clube_metodo_cobranca_data_especifica = this.parseDate(
        this.dateFormatted
      );
    }
  },
  created() {
    this.getPlanos();
    this.getContas();
    this.validaEdicaoModulo();
  },
  methods: {
    checkPeriodo() {
      if (!this.checkboxPeriodo) {
        this.novos_planos.plano_clube_maximo_mensalidades = 0;
      }
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },

    addVal(a) {
      if (a == "nome") {
        this.novos_planos.plano_clube_email_template =
          this.novos_planos.plano_clube_email_template + "{%NomeAssociado%}";
      }
      if (a == "plano") {
        this.novos_planos.plano_clube_email_template =
          this.novos_planos.plano_clube_email_template + "{%Plano%}";
      }
    },
    clearCampos() {
      this.novos_planos = {
        plano_publico: 0,
        id_plano_clube: "",
        plano_clube_nome: "",
        plano_clube_descricao: "",
        plano_clube_gratuito: "",
        plano_clube_periodo_indeterminado: "",
        plano_clube_valor: "",
        plano_clube_metodo_pagamento: "",
        plano_clube_metodo_cobranca: "",
        plano_clube_maximo_mensalidades: "1",
        plano_clube_metodo_cobranca_competencia_inicio: "",
        plano_clube_metodo_cobranca_competencia_fim: "",
        plano_clube_metodo_cobranca_data_especifica: "",
        plano_clube_email_template: "",
        plano_clube_provisionamento_meses: 1,
        plano_clube_periodo_pagamento: "",
        dias_gerar_debito: "",
        fk_id_conta: ""
      };
    },
    deleteItem() {
      this.loading = true;
      Api.delete(`/planos-clubes/` + this.formData.id_plano_clube)
        .then(response => {
          this.$toast.success("Excluído com sucesso!");
          this.formData.id_plano_clube = "";
          this.getPlanos();
          this.loading = false;

          if (!response.data.errors) {
            this.$toast.success("Excluído com sucesso!");
            this.formData.id_plano_clube = "";
            this.getPlanos();
            this.loading = false;
          } else {
            this.$toast.warning(response.data.errors);
            this.loading = false;
          }
        })
        .catch(err => {
          this.loading = false;
          throw err;
        });
    },
    menu(opcao, item) {
      this.formData.id_plano_clube = item.id_plano_clube;
      if (opcao.nome === "⠀Excluir") {
        this.dialog_delete = true;
      } else if (opcao.nome === "⠀Editar") {
        this.date = item.plano_clube_metodo_cobranca_data_especifica
          ? item.plano_clube_metodo_cobranca_data_especifica
          : "";
        if (item.plano_clube_periodo_indeterminado == 1) {
          this.checkboxPeriodo = true;
        } else {
          this.checkboxPeriodo = false;
        }
        // if (item.plano_publico == 1) {
        //   this.novos_planos.plano_publico = true;
        // } else {
        //   this.novos_planos.plano_publico = false;
        // }
        this.novos_planos = {
          plano_publico: item.plano_publico == 1 ? "1" : "0",
          plano_clube_periodo_indeterminado:
            item.plano_clube_periodo_indeterminado,
          id_plano_clube: item.id_plano_clube,
          plano_clube_nome: item.plano_clube_nome,
          plano_clube_descricao: item.plano_clube_descricao,
          plano_clube_gratuito: item.plano_clube_gratuito,
          plano_clube_valor: item.plano_clube_valor,
          plano_clube_metodo_pagamento: item.plano_clube_metodo_pagamento,
          plano_clube_metodo_cobranca: item.plano_clube_metodo_cobranca,
          plano_clube_metodo_cobranca_competencia_inicio:
            item.plano_clube_metodo_cobranca_competencia_inicio,
          plano_clube_metodo_cobranca_competencia_fim:
            item.plano_clube_metodo_cobranca_competencia_fim,
          plano_clube_metodo_cobranca_data_especifica: item.plano_clube_metodo_cobranca_data_especifica
            ? item.plano_clube_metodo_cobranca_data_especifica
            : "",
          plano_clube_email_template: item.plano_clube_email_template,
          plano_clube_provisionamento_meses:
            item.plano_clube_provisionamento_meses,
          fk_id_conta: item.fk_id_conta ? item.fk_id_conta : "",
          plano_clube_maximo_mensalidades: item.plano_clube_maximo_mensalidades,
          dias_gerar_debito: item.dias_gerar_debito,
          plano_clube_periodo_pagamento: item.plano_clube_periodo_pagamento
            ? item.plano_clube_periodo_pagamento
            : ""
        };
        this.dialog_planos = true;
      }
    },
    save() {
      this.loading = true;
      if (this.$refs.form.validate()) {
        let edit = "";
        if (this.novos_planos.id_plano_clube) {
          edit = "/" + this.novos_planos.id_plano_clube;
        }
        if (this.checkboxPeriodo) {
          this.novos_planos.plano_clube_periodo_indeterminado = 1;
        } else {
          this.novos_planos.plano_clube_periodo_indeterminado = 0;
        }
        // if (this.novos_planos.plano_publico) {
        //   this.novos_planos.plano_publico = 1;
        // } else {
        //   this.novos_planos.plano_publico = 0;
        // }
        Api.post("/planos-clubes" + edit, this.novos_planos)
          .then(response => {
            this.loading = false;
            if (response.data) {
              if (!this.novos_planos.id_plano_clube) {
                this.$toast.success("Cadastrado com sucesso!");
              } else {
                this.$toast.success("Editado com sucesso!");
              }
            }
            this.getPlanos();
            this.$refs.form.resetValidation();
            this.close();
          })
          .catch(err => {
            this.loading = false;
            this.$toast.error("Oops! Ocorreu um erro.");
            throw err;
          });
      }
    },

    getPlanos() {
      this.loading = true;
      Api.get(`/planos-clubes`)
        .then(response => {
          if (response.data.data) {
            this.formData = response.data.data;
            this.loading = false;
          }
        })
        .catch(err => {
          this.loading = false;
          throw err;
        });
    },

    getContas() {
      Api.get(`/contas`)
        .then(response => {
          if (response.data.data) {
            this.contas = response.data.data;
          }
        })
        .catch(err => {
          throw err;
        });
    },
    carregarMais() {
      if (this.formData.length > this.items_per_pag) {
        this.items_per_pag += 10;
      }
    },
    close() {
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
      if (this.$refs.form2) {
        this.$refs.form2.resetValidation();
      }
      this.dialog_planos = false;
      this.dialog_edit_planos = false;
      this.date = "";
      this.novos_planos = {
        plano_clube_periodo_indeterminado: "",
        id_plano_clube: "",
        plano_clube_nome: "",
        plano_clube_descricao: "",
        plano_clube_gratuito: "",
        plano_clube_valor: "",
        plano_clube_metodo_pagamento: "",
        plano_clube_metodo_cobranca: 3,
        plano_clube_metodo_cobranca_competencia_inicio: "",
        plano_clube_metodo_cobranca_competencia_fim: "",
        plano_clube_metodo_cobranca_data_especifica: "",
        plano_clube_email_template: "",
        plano_clube_provisionamento_meses: 12,
        fk_id_conta: "",
        plano_clube_periodo_pagamento: ""
      };
    },
    // edit() {
    //   this.loading = true;
    //   if (this.$refs.form2.validate()) {
    //     Api.post(
    //       `/planos-clubes/` + this.formData.id_plano_clube,
    //       this.novos_planos
    //     )
    //       .then((response) => {
    //         if (response) {
    //           this.loading = false;
    //         }
    //         this.loading = false;
    //         this.$toast.success("Editado com sucesso!");
    //         this.formData.id_plano_clube = "";
    //         this.getPlanos();
    //         this.close();
    //       })
    //       .catch((err) => {
    //         this.loading = false;
    //         this.$toast.error("Oops! Ocorreu um erro.");
    //         throw err;
    //       });
    //   }
    // },
    novoPlano() {
      this.dialog_planos = true;
    },
    async validaEdicaoModulo() {
      this.editModulo = await Api.validaEdicaoModulo(
        this.$router.currentRoute.path
      );
    }
  }
};
</script>
<style lang="scss">
input:disabled {
  cursor: default;
  border-color: #bdbdbd;
  color: #bdbdbd;
}
</style>